import { api } from './client';

export interface Notification {
  id: number;
  type: string;
  title: string;
  body: string;
  relatedEntityId: string | null;
  sentByName: string | null;
  isRead: boolean;
  createdAt: string;
}

export interface NotificationsResult {
  notifications: Notification[];
  unreadCount: number;
  hasMore: boolean;
  nextCursor: number | null;
}

export type NotificationScope = 'andbook' | 'core';

export function getMyNotifications(cursor?: number | null, scope?: NotificationScope): Promise<NotificationsResult> {
  const p = new URLSearchParams();
  if (cursor != null) p.set('cursor', String(cursor));
  if (scope) p.set('scope', scope);
  const qs = p.toString();
  return api.get<NotificationsResult>(`/api/notifications/me${qs ? `?${qs}` : ''}`);
}

export function markNotificationRead(id: string): Promise<{ id: string; isRead: boolean }> {
  return api.patch<{ id: string; isRead: boolean }>(`/api/notifications/${id}/read`);
}

export function markAllNotificationsRead(scope?: NotificationScope): Promise<{ ok: boolean }> {
  return api.patch<{ ok: boolean }>(`/api/notifications/me/read-all${scope ? `?scope=${scope}` : ''}`);
}
